import React from "react";
import NumberFormat from "react-number-format";
import { useTranslation } from "react-i18next";
import { IPurchaseHistoryItem } from "redux/reducers/purchaseHistorySlice";
import "./styles.scss";

interface PurchasedPointHistoryItemProp {
  purchaseHistoryItem: IPurchaseHistoryItem;
  index: number;
}

const PurchasedPointHistoryItem: React.FC<PurchasedPointHistoryItemProp> = (
  props
) => {
  const { t } = useTranslation();
  const { purchaseHistoryItem, index } = props;
  return (
    <div className="purchased_points_history_item">
      <span className="purchased_points_history_item_index">{index + 1} </span>
      <div className="purchased_points_history_item_date">
        {purchaseHistoryItem.date.substring(0, 10)}
      </div>
      <div className="item_row">
        <NumberFormat
          value={purchaseHistoryItem.points}
          displayType={"text"}
          className="purchased_points_history_item_amount"
          thousandSeparator={true}
        />
        <label>{t("purchaseHistory.purchaseHistoryItem.span.points")}</label>
        {purchaseHistoryItem.type === "purchased" && (
          <span className="purchased_points_history_item_text">
            {t("purchaseHistory.purchaseHistoryItem.span.worthOf")}
          </span>
        )}
        {purchaseHistoryItem.type === "purchased" && (
          <NumberFormat
            value={purchaseHistoryItem.amount}
            displayType={"text"}
            className="present_available_total_amount"
            thousandSeparator={true}
            type={"text"}
            suffix={t("purchaseHistory.purchaseHistoryItem.span.JPY")}
          />
        )}
        <span className="purchased_points_history_item_status">
          {purchaseHistoryItem.type === "purchased" ? (
            <span className="purchased">
              {t("purchaseHistory.purchaseHistoryItem.span.purchased")}
            </span>
          ) : purchaseHistoryItem.type === "used" ? (
            t("purchaseHistory.purchaseHistoryItem.span.used")
          ) : purchaseHistoryItem.type === "refunded" ? (
            t("purchaseHistory.purchaseHistoryItem.span.refunded")
          ) : (
            t("purchaseHistory.purchaseHistoryItem.span.awarded")
          )}
        </span>
      </div>
    </div>
  );
};

export default PurchasedPointHistoryItem;
